import React, { useState } from "react";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PdfPreview from "../../../Common/PDFPreview";
import { formatDate } from "../../../Common/FormatFunctions/FormatDate";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import axios from "axios";

const CheckReportFormMultiplecompanyentries = ({ Id, disabledFeild }) => {
    const API_URL = process.env.REACT_APP_API;
    const apikey = process.env.REACT_APP_API_URL;
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")

    const [pdfPreview, setPdfPreview] = useState(null);
    const [apiData, setAPIData] = useState([]);
    const [isBillToShipToSame, setIsBillToShipToSame] = useState(true);

    const fetchData = async () => {
        try {
            if (!API_URL) {
                alert("Configuration error: API URL not found");
                return;
            }

            const response = await axios.get(
                `${API_URL}/TransferDataTo-RTGS-FromCompanyEntries`,
                {
                    params: {
                        CompanyCode: companyCode,
                        Year_Code: Year_Code,
                        Id: Id
                    }
                }
            );

            const data = response.data;

            if (!data.all_data || !data.all_data[0]) {
                throw new Error("No data received from server");
            }

            setAPIData(data.all_data);
            generatePdf(data.all_data);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("Error: " + error.message);
        }
    };

    const generatePdf = (data) => {
        // Add validation
        if (!data || !data[0]) {
            console.error("No data to generate PDF");
            return;
        }

        const allData = data[0];

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        pdf.setFont("Helvetica");

        /* A/C PAYEE */
        pdf.setFontSize(12);
        pdf.text("A/C Payee", 120, 3);

        /* PAYEE NAME - with null check */
        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        // Handle undefined PartyName
        const partyName = allData.RTGSPARTYNAME ? allData.RTGSPARTYNAME.trim() : "Unknown";
        pdf.text(
            `${partyName}`,
            25,
            14,
            { maxWidth: 140 }
        );

        /* AMOUNT IN WORDS - with null check */
        const amount = allData.Amount || 0;
        const amountWords = ConvertNumberToWord(amount);
        pdf.setFont("Helvetica", "normal");
        pdf.setFontSize(12);
        pdf.text(
            amountWords,
            30,
            22,
            { maxWidth: 150 }
        );

        /* AMOUNT IN NUMBERS - with proper formatting */
        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        // Format amount to handle both string and number
        const formattedAmount = typeof amount === 'number'
            ? amount.toFixed(2)
            : parseFloat(amount).toFixed(2);

        pdf.text(
            formattedAmount,
            165,
            30,
            { maxWidth: 150 }
        );

        /* DATE - with error handling */
        const splitDateDigits = (dateStr) => {
            if (!dateStr) return [];
            try {
                const [dd, mm, yyyy] = dateStr.split("/");
                return [...dd, ...mm, ...yyyy];
            } catch (e) {
                console.error("Date parsing error:", e);
                return [];
            }
        };

        const dateDigits = splitDateDigits(allData.Date);
        const dateBoxStartX = 162;
        const dateBoxY = 3;
        const boxGap = 5;

        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        dateDigits.forEach((digit, index) => {
            pdf.text(
                digit,
                dateBoxStartX + index * boxGap,
                dateBoxY,
                { align: "center" }
            );
        });

        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfPreview(pdfUrl);
    };

    return (
        <div id="pdf-content">
            {pdfPreview && (
                <PdfPreview
                    pdfData={pdfPreview}
                    apiData={apiData[0]}
                    label={"UTR"}
                />
            )}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Cheque Print"} />
        </div>
    );
};

export default CheckReportFormMultiplecompanyentries;


